import React, { useState } from 'react';
const faqs = [{
  question: '¿Cómo recibo el Megapack después de comprar?',
  answer: 'En el momento en que confirmás el pago recibís un mail con el acceso a todos los materiales. No hay espera, no hay envío físico. Todo es digital y lo podés abrir desde el celular, la tablet o la computadora en menos de 5 minutos.'
}, {
  question: '¿Sirve para cualquier año de la carrera?',
  answer: 'Sí. Los 6 tomos están ordenados por bloque temático y cubren toda la carrera: desde primer año con anatomía, fisiología y fundamentos, hasta las prácticas hospitalarias de tercer año con técnicas, PAE y documentación clínica. Lo usás según lo que estés cursando en este momento.'
}, {
  question: '¿Sirve si recién arranqué la carrera?',
  answer: 'Es ideal para eso. El Tomo 1 está pensado específicamente para primer año: cómo organizar la cursada, el método Cornell adaptado a Enfermería y un sistema para no perderse nunca más. No asume conocimiento previo — te da el marco para arrancar con confianza desde el día uno.'
}, {
  question: '¿Funciona para estudiar para finales difíciles?',
  answer: 'Sí. Cada tomo incluye ejercicios de autoevaluación, glosario de términos clave y resúmenes por capítulo. El Bono 01 tiene un banco de preguntas tipo final armado con lo que más toman los docentes. Varios estudiantes aprobaron materias que habían recursado usando exactamente eso.'
}, {
  question: '¿Los materiales editables de qué nivel son?',
  answer: 'Los editables premium están incluidos en el Enfermero Total: Kit Premium™. Son plantillas y documentos en formato editable — planillas de PAE, cronogramas de cursada, checklists de procedimientos y organizadores de apuntes — que podés adaptar a tu carrera. Si elegís el Megapack base, los materiales vienen en PDF listos para usar.'
}, {
  question: '¿Qué diferencia hay entre el Megapack y el Kit Premium?',
  answer: 'Los dos arrancan con los 6 Tomos y 6 Bonos completos. El Kit Premium le suma plantillas editables, planillas de PAE, cronogramas y organizadores para que tengas todo tu sistema de estudio armado desde el primer día.'
}, {
  question: '¿Qué pasa si tengo materias con mucho contenido teórico?',
  answer: 'Está pensado para eso. En lugar de darte teoría suelta, cada tomo organiza el contenido con lógica clínica y ejemplos aplicados. Anatomía, Farmacología y las materias filtro — las que más asustan — tienen capítulos completos con casos resueltos y guías de estudio paso a paso.'
}, {
  question: '¿Qué diferencia tiene con apuntes o resúmenes del mercado?',
  answer: 'La mayoría de los apuntes que circulan son teoría desorganizada o resúmenes de una sola cátedra. El Enfermero Total: Carrera Resuelta™ es un sistema de estudio completo: arranca por lo que vas a necesitar en el parcial o final y te da el camino más corto para llegar. Casos resueltos, banco de preguntas, calculadora de dosis y guías por materia — todo en un solo lugar.'
}, {
  question: '¿Funciona para cualquier institución?',
  answer: 'Sí. El contenido está armado sobre el núcleo común de la carrera de Enfermería en Argentina y es compatible con terciarios y universidades de todo el país. Las materias pueden tener nombres distintos, pero el contenido base es el mismo en todas las instituciones.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. Tenés 7 días desde el momento de la compra para revisarlo todo. Si no es lo que esperabas te devolvemos el 100% del dinero sin preguntas, sin formularios y sin drama. La tasa de devolución es menor al 1% — no porque no se pueda pedir, sino porque el material habla por sí solo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(240,249,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(219,234,254) 100%)'
  }} data-id="element-150">
      <div className="mx-auto max-w-4xl" data-id="element-151">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-152">
          Preguntas <span className="text-blue-700" data-id="element-153">frecuentes</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-154">
          Todo lo que necesitás saber antes de decidir.
        </p>

        {/* Accordion */}
        <div className="flex flex-col gap-2" data-id="element-155">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-white rounded-xl overflow-hidden shadow-sm transition-all" style={{
            border: isOpen ? '1px solid rgba(59,130,246,0.5)' : '1px solid rgba(59,130,246,0.15)'
          }} data-id="element-156">
                {/* Question */}
                <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-5 py-4 m-0" style={{
              fontFamily: 'inherit'
            }} data-id="element-157">
                  <span className="text-sm font-bold" style={{
                color: isOpen ? '#1d4ed8' : '#111827'
              }} data-id="element-158">
                    {i + 1}. {faq.question}
                  </span>
                  <span className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-white text-base font-black transition-transform duration-300" style={{
                backgroundColor: '#1d4ed8',
                transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
              }} data-id="element-159">
                    +
                  </span>
                </button>

                {/* Answer */}
                {isOpen && <div className="px-5 pb-4" style={{
              borderTop: '1px solid rgba(59,130,246,0.1)'
            }} data-id="element-160">
                    <p className="text-sm text-gray-600 leading-relaxed m-0 pt-3" data-id="element-161">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}